/* eslint-disable no-magic-numbers */
import React, { ReactNode } from 'react';

import { FormattedMessage, useIntl } from '@futrli/localisation';
import { UILoader } from '@futrli/ui-components';
import Dialog from 'carbon-react/lib/components/dialog';
import Form from 'carbon-react/lib/components/form';
import Button from 'carbon-react/lib/components/button';
import Typography from 'carbon-react/lib/components/typography';

interface Props {
  isOpen?: boolean;
  isLoading: boolean;
  handleCloseDialog: () => void;
  onSubmit: () => void;
  message?: ReactNode;
}

export const DeleteScheduleReportDialog = ({ isOpen, isLoading, handleCloseDialog, onSubmit, message }: Props) => {
  const intl = useIntl();

  return (
    <Dialog
      title={intl.formatMessage({ id: 'common.warning_deletion', defaultMessage: 'Warning: deletion is irreversible' })}
      onCancel={handleCloseDialog}
      open={!!isOpen}
      size="medium"
      greyBackground
      contentPadding={{
        p: isLoading ? 2 : 0
      }}
    >
      {isLoading ? (
        <UILoader />
      ) : (
        <Form
          stickyFooter
          leftSideButtons={
            <Button onClick={handleCloseDialog} size="small">
              <FormattedMessage id="common.cancel" defaultMessage="Cancel" />
            </Button>
          }
          saveButton={
            <Button buttonType="primary" size="small" onClick={onSubmit} destructive>
              {<FormattedMessage id="common.delete" defaultMessage="Delete" />}
            </Button>
          }
          onSubmit={onSubmit}
        >
          <Typography fontSize="16px" mb={0} px={4} pt="20px" pb="40px">
            {message ? (
              message
            ) : (
              <FormattedMessage
                id="predict.are_you_sure_delete_scheduled_report"
                defaultMessage="Are you sure you want to delete this scheduled report?"
              />
            )}
          </Typography>
        </Form>
      )}
    </Dialog>
  );
};
